export default __webpack_public_path__ + "static/turquoisewaxdust-c335b2f6da388bffefcad079b4e393f0.png";